import XLink from '../common/XLink';
import XButton from '../common/XButton';
import RenderIf from '../render-if/Renderif';
import ViewIcon from '../../assets/icons/ViewIcon.svg?react';
import EditIconBlue from '../../assets/icons/EditIconBlue.svg?react';
import { cn } from '../../utils/classNames';
import useCertifiedLifecareCompany from "../../hooks/useCertifiedLifecareCompany";

const iconClasses = 'h-action-icon w-action-icon flex-none text-primary';
const iconOnlyClasses = 'px-action-icon-only-x justify-center!';

const EditCaseButton = ({ caseId, text = "", isIconIncluded = true, className = "", variant = "actionOutline", disabled = false, onClick }) => {
    const isIconOnly = !text && isIconIncluded;
    const isCertifiedLifecareCompany = useCertifiedLifecareCompany();
    const buttonClasses = cn(isIconOnly && iconOnlyClasses, className);

    const content = (
        <>
            <RenderIf shouldRender={isIconIncluded}>
                {isCertifiedLifecareCompany ? <ViewIcon className={iconClasses} /> : <EditIconBlue className={iconClasses} />}
            </RenderIf>
            <RenderIf shouldRender={text}>
                <span>{text}</span>
            </RenderIf>
        </>
    );

    // a link cannot truly be disabled, so a running virtual user swaps it for a real disabled button
    if (disabled) {
        return (
            <XButton
                type="button"
                variant={variant}
                className={buttonClasses}
                disabled
                aria-label={text ? undefined : "Edit case"}
            >
                {content}
            </XButton>
        );
    }

    return (
        <XLink
            to={`/case/edit/${caseId}`}
            variant={variant}
            className={buttonClasses}
            aria-label={text ? undefined : "Edit case"}
            onClick={onClick}
        >
            {content}
        </XLink>
    );
};

export default EditCaseButton;
